export default "__VITE_ASSET__CBo$Wv3w__"